import { render, staticRenderFns } from "./CreateFloatingButton.vue?vue&type=template&id=0b727bed&"
import script from "./CreateFloatingButton.vue?vue&type=script&lang=ts&"
export * from "./CreateFloatingButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports